var exports = {
  "kL": "GroupedVoiceParticipant.module__container___MEduN0",
  "AG": "GroupedVoiceParticipant.module__participantButton___MEduN0",
  "IT": "GroupedVoiceParticipant.module__participantButtonSpeaking___MEduN0",
  "O": "GroupedVoiceParticipant.module__participantButtonContextMenuActive___MEduN0",
  "SX": "GroupedVoiceParticipant.module__avatarAndName___MEduN0",
  "VW": "GroupedVoiceParticipant.module__nameContainer___MEduN0",
  "F8": "GroupedVoiceParticipant.module__participantName___MEduN0",
  "xr": "GroupedVoiceParticipant.module__participantNameSpeaking___MEduN0",
  "S$": "GroupedVoiceParticipant.module__participantNameCurrent___MEduN0",
  "u$": "GroupedVoiceParticipant.module__deviceCountButton___MEduN0",
  "g0": "GroupedVoiceParticipant.module__iconsAndToggle___MEduN0",
  "pP": "GroupedVoiceParticipant.module__devicesContainer___MEduN0",
  "nt": "GroupedVoiceParticipant.module__flexShrinkZero___MEduN0",
};

module.exports = exports;
